// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--KvYxP","inner":"_93444fe79c--inner--hzomk","description-wrapper":"_93444fe79c--description-wrapper--kwMzy"};